import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { IDLE, PENDING, EDIT } from "const"
import {
    StateType,
    hasAccess,
    hasProjectAccess,
    hasLifecycleAccess,
} from "client/utils"
import {
    PRM_LIFECYCLE,
    PRM_LIFECYCLE_PERMISSIONS,
    StoreType,
    AccountUserList,
    ProjectUserList,

    LoadLifecyclePermissions,
    LoadAccountGroups,
    LoadAccountUsers,
    LoadProjectGroups,
    LoadProjectUsers,
    IsOwnerLifecycle,
    SaveLifecyclePermissions,

    setLifecyclePermissions,
    setLifecyclePermissionsReloadList,
    setGroupList,
    setProjectGroupList,
    setProjectUserList,
    setAccountUserList,
} from "client/store"
import {
    Container,
    PageContent,
    Loader,
    PageForm,
    PermissionTable,
    Button,
    SpinnerIcon,
} from "client/components"

import Columns from "./columns"

let isMounted: boolean

const LifecyclePermissions = () => {
    const lifecycle = useSelector((state: StoreType) => state.lifecycle.lifecycleView)
    const lifecyclePermissions = useSelector((state: StoreType) => state.lifecyclePermissions.lifecyclePermissions)
    const reloadList = useSelector((state: StoreType) => state.lifecyclePermissions.reloadList)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        if (!reloadList || !lifecycle) return
        setLoadState(PENDING)
        const promiseArray: Promise<any>[] = [
            LoadLifecyclePermissions(lifecycle.id, lang).then((res) => {
                dispatch(setLifecyclePermissions(res.permissionsSectioned))
            }),
            LoadAccountGroups(userData.accountId).then((res) => {
                dispatch(setGroupList(res))
            }),
        ]

        if (project.id) {
            promiseArray.push(
                LoadProjectGroups(userData.accountId, project.id, true).then((res) => {
                    dispatch(setProjectGroupList(res))
                }),
                LoadProjectUsers(project.id).then((res) => {
                    const newProjectUserList: ProjectUserList = { [project.id]: res }
                    dispatch(setProjectUserList(newProjectUserList))
                }),
            )
        } else {
            promiseArray.push(
                LoadAccountUsers(userData.accountId).then((res) => {
                    const newAccountUserList: AccountUserList = { [userData.accountId]: res }
                    dispatch(setAccountUserList(newAccountUserList))
                }),
            )
        }

        Promise.all(promiseArray).then(() => {
            setLoadState(IDLE)
        })
    }, [reloadList, lifecycle])

    const onCancel = () => {
        dispatch(setLifecyclePermissionsReloadList(false))
        setTimeout(() => {
            dispatch(setLifecyclePermissionsReloadList(true))
        }, 0)
    }

    const onApply = () => {
        setApplyState(PENDING)
        SaveLifecyclePermissions(lifecycle.id, lifecyclePermissions)
        .then(() => {
            if (isMounted) setApplyState(IDLE)
        })
    }


    const editAccess = !project.id
        ? hasAccess(PRM_LIFECYCLE, EDIT)
        : hasProjectAccess(PRM_LIFECYCLE, EDIT)

    const permissionsEditAccess = hasLifecycleAccess(PRM_LIFECYCLE_PERMISSIONS, EDIT)
    const isOwner = IsOwnerLifecycle(project.id, lifecycle, userData)

    const allowedToEditPermissions = editAccess || isOwner || permissionsEditAccess

    const columns = Columns(allowedToEditPermissions)

    return (
        <Container>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <PermissionTable
                    columns={columns}
                    section="lifecycle"
                    dataList={lifecyclePermissions.lifecycle}
                />

                {
                    allowedToEditPermissions && (
                        <PageForm>
                            <Row>
                                <Col xs={12}>
                                    <Button variant="success" row onClick={() => onApply()}>
                                        {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                                    </Button>
                                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                                </Col>
                            </Row>
                        </PageForm>
                    )
                }
            </PageContent>
        </Container>
    )
}
export default LifecyclePermissions
